import MapCard from 'app/containers/Map/parts/MapCard/MapCard';
import { MapModeEnum } from 'app/containers/Map/slice/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {}

const RunsWithoutTaskMapCard: FC<IProps> = () => {
  const { t } = useTranslation();

  return (
    <MapCard
      title={t('Task.List.RunsWithoutTask', 'Routes without task')}
      mode={MapModeEnum.runsWithoutTask}
      showCulturesMenu={false}
      showLayerMenu={false}
    />
  );
};

export default RunsWithoutTaskMapCard;
